export default "__VITE_ASSET__DJ2TVbIs__"